import React from "react";
import moment from "moment";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback } from "../../helper/helper";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const ViewTournament = ({ setUserView, userView, deleteSelected }) => {
  // "";

  return (
    <>
      <Modal
        open={userView}
        onClose={() => setUserView(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="deleteModal view_user_Modal"
          sx={{ padding: "0", overflow: "hidden" }}
        >
          <Box sx={{ overflow: "auto", height: "100%", maxHeight: "45vh" }}>
            <Card sx={{}}>
              <CardMedia>
                <Box className="p_image">
                  <ImageWithFallback
                    src={
                      deleteSelected.current && deleteSelected.current.thumbnail
                    }
                    alt={""}
                    fallbackSrc={BlankImg}
                  />
                  <Box className="playIcon-wrapper">
                    <Box
                      component={Link}
                      href={
                        deleteSelected.current &&
                        deleteSelected.current.video_link
                      }
                      target="_blank"
                    >
                      <PlayArrowIcon className="playIcon" />
                    </Box>
                  </Box>
                </Box>
              </CardMedia>
              <CardContent>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 0, width: "100%" }}
                    aria-label="simple table"
                  >
                    <TableBody>
                      <TableRow
                        key="Mtitle"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          TITLE
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ maxWidth: "200px", wordBreak: "break-all" }}
                        >
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.title}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mdescription"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          REGION
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.region}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mclub_name"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          POSTED BY
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.goalUserDetails.firstName +
                              " " +
                              deleteSelected.current.goalUserDetails.lastName}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mregion"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          CATEGORY
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          <Typography component={"p"}>
                            {deleteSelected.current
                              ? `${deleteSelected.current.gCategory}              
                              `
                              : null}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {deleteSelected.current &&
                      deleteSelected.current?.gSubCategory ? (
                        <TableRow
                          key="Mregion"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            className="modal_table_head"
                          >
                            SUB CATEGORY
                          </TableCell>
                          <TableCell align="left">
                            {" "}
                            <Typography component={"p"}>
                              {deleteSelected.current
                                ? `${
                                    deleteSelected.current?.gSubCategory
                                      ? deleteSelected.current?.gSubCategory
                                      : ""
                                  }`
                                : null}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : null}
                      <TableRow
                        key="MFrom"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          FROM
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                          deleteSelected.current.from_uk
                            ? "UK"
                            : "Outside UK"}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mvisibility"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          CLUB
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.club}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  sx={{ color: "#EF364E" }}
                  onClick={() => setUserView(false)}
                >
                  Exit
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewTournament;
